import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import {
  CardModule,
  IconModule, PromotionsModule
} from '@spartacus/storefront';
import { CartSharedModule } from '@spartacus/cart/base/components';
import { KnBrReviewSubmitComponent } from './kn-br-review-submit.component';

@NgModule({
    imports: [
        CommonModule,
        CardModule,
        CartSharedModule,
        I18nModule,
        UrlModule,
        RouterModule,
        PromotionsModule,
        IconModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CheckoutReviewOrder: {
                    component: KnBrReviewSubmitComponent,
                    // TODO(#8880): Shouldn't we keep ShippingAddressSetGuard and others here?
                    guards: [CheckoutAuthGuard, CartNotEmptyGuard],
                },
            },
        } as CmsConfig),
        KnBrReviewSubmitComponent,
    ],
    exports: [KnBrReviewSubmitComponent],
})
export class KnBrReviewSubmitModule { }
